import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { OpenConfirmModalPayload } from './types';
import type { ReactNode } from 'react';

interface GlobalConfirmModalState {
  isOpen: boolean;
  title: string;
  text: string | ReactNode;
  confirmButtonLabel?: string;
  cancelButtonLabel?: string;
  onConfirm: () => Promise<void> | void;
  onClose?: () => void;
}

const initialState: GlobalConfirmModalState = {
  isOpen: false,
  title: '',
  text: '',
  onConfirm: () => {},
  onClose: undefined,
};

export const globalConfirmModalSlice = createSlice({
  name: 'globalConfirmModal',
  initialState,
  reducers: {
    openModal: (_, { payload }: PayloadAction<OpenConfirmModalPayload>) => ({
      isOpen: true,
      title: payload.title,
      text: payload.text,
      confirmButtonLabel: payload.confirmButtonLabel,
      cancelButtonLabel: payload.cancelButtonLabel,
      onConfirm: payload.onConfirm,
      onClose: payload.onClose,
    }),
    closeModal: () => initialState,
  },
});

export const globalConfirmModalReducer = globalConfirmModalSlice.reducer;
export const globalConfirmModalActions = globalConfirmModalSlice.actions;
